import {
  LOAD_ALL_WAREHOUSE,
  LOAD_SINGLE_WAREHOUSE,
} from "./WarehouseList.saga";

export const loadAllWarehouse = (payload) => ({
  type: LOAD_ALL_WAREHOUSE.LOADING,
  payload,
});

export const loadSingleWarehouse = (payload) => ({
  type: LOAD_SINGLE_WAREHOUSE.LOADING,
  payload,
});
